import { z } from 'zod';

/** Quote line vs supplemental OS line added after the order already existed. */
export const ConsumerDecidedItemSourceSchema = z.enum(['quote', 'service-order']);
export type ConsumerDecidedItemSource = z.infer<typeof ConsumerDecidedItemSourceSchema>;

export const ConsumerDecidedItemDecisionSchema = z.enum(['approved', 'rejected']);
export type ConsumerDecidedItemDecision = z.infer<typeof ConsumerDecidedItemDecisionSchema>;

export const ConsumerDecidedItemsQuerySchema = z.object({
  decision: ConsumerDecidedItemDecisionSchema,
});
export type ConsumerDecidedItemsQuery = z.infer<typeof ConsumerDecidedItemsQuerySchema>;

export const ConsumerDecidedItemSchema = z.object({
  id: z.uuid(),
  source: ConsumerDecidedItemSourceSchema,
  sourceId: z.uuid(),
  quoteId: z.uuid().nullable(),
  quoteVersion: z.number().int().positive().nullable(),
  serviceOrderId: z.uuid().nullable(),
  serviceOrderDisplayNumber: z.string().nullable(),
  workshopName: z.string().min(1),
  tenantId: z.uuid(),
  vehiclePlate: z.string().nullable(),
  description: z.string(),
  itemType: z.string().min(1),
  quantity: z.string().min(1),
  totalCents: z.string().min(1),
  currency: z.string().min(1),
});
export type ConsumerDecidedItem = z.infer<typeof ConsumerDecidedItemSchema>;

export const ConsumerDecidedItemsResponseSchema = z.object({
  items: z.array(ConsumerDecidedItemSchema),
});
export type ConsumerDecidedItemsResponse = z.infer<typeof ConsumerDecidedItemsResponseSchema>;
